import React, {useState, useEffect} from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core/styles';
import Zoom from '@material-ui/core/Zoom';
import SortableTree, {addNodeUnderParent, removeNodeAtPath, toggleExpandedForAll} from 'react-sortable-tree';
import 'react-sortable-tree/style.css'; // This only needs to be imported once in your app
import FileExplorerTheme from 'react-sortable-tree-theme-minimal';
import uuid from 'react-uuid'
import {
  setPickedNodeId,
  setTreeData,
  setNodeDefWight,
  calculteScores,
  setTreeBuildData,
  setNodesData,
  setPickedTreeId,
  setNodeWight,
  throttledLoadOptions,
  addOptionQueryParam,
  setPrefernceItem
} from '../../redux/actions'
import {getTreeData} from '../../dbApi/DbApi'
import {connect} from 'react-redux'
import MyRangeInput from '../MyRangeInput'
import {PrefernceLink} from '../../linkManager/Links'
import {RUNNING, SUCSSES, ERROR} from '../../redux/actions';
import {DOWNLOAD_CONTEXT_PROCESS} from '../OptionsFragmentControler'

const NodeTollip = withStyles((theme) => ({
  tooltip: {
    fontSize: 15,
  },
}))(Tooltip);


const ShowLogicTree = (props) => {
  const [treeRepesntation, setTreeRepesntation] = useState([]);
  const [treeId, setTreeId] = useState();
  const [curNodeTitle, setCurNodeTitle] = useState();
  const [expanded, setExpanded] = useState(false);


  const optionsUrl =
    `/choose?treeId=${props.queryParams.treeId}&category=${props.queryParams.category}&ordering=-score&`

  const [loadingContext, setLoadingContext] = useState(false);

  useEffect(() => {
    console.log(`mounted with id:${props.preferenceTree.id}`);
    console.log(props.preferenceTree.root_node);
    if (props.preferenceTree.id) {
      setTreeRepesntation(_getTreeRepsentation([props.preferenceTree.root_node]))
    }
  }, [])

  useEffect(() => {
    if (props.preferenceTree.id) {
      setTreeId(props.preferenceTree.id)
      setTreeRepesntation(_getTreeRepsentation([props.preferenceTree.root_node]))
    }
  }, [props.preferenceTree.id])

  useEffect(() => {
    console.log("called refresh");
    _refreshTreeRepesntation()
  }, [props.nodesData])

  useEffect(() => {
    setLoadingContext(props.loadingTreeContextState == RUNNING)
    console.log("setting load context to");
    console.log(props.loadingTreeContextState == RUNNING);
    console.log(loadingContext);
  }, [props.loadingTreeContextState])

  const _toggleNodeExpansion = (expanded) => {
    setTreeRepesntation(toggleExpandedForAll({treeData: treeRepesntation, expanded}))
  };

  const _shouldShowNode = (node) => {
    let id = node.id;
    let nodeData = props.nodesData[id]
      ? props.nodesData[id]
      : {};
    console.log(`visibilty: ${nodeData.visibilty}`);
    if (typeof(nodeData.visibilty) === 'undefined') {
      /* the defualt behavior when nothing was declared */
      return true;/* if not said to not show, then show */
    }
    return nodeData.visibilty;
  }
  const _getNodeRepsentation = (node_data) => {
    console.log(node_data);
    if (node_data) {
      console.log("nodes data");
      console.log(props.nodesData);
      let nodeContext = props.nodesData[node_data.id]
        ? props.nodesData[node_data.id]
        : {}
      let node_repsentation = {
        ...node_data
      };
      node_repsentation["nodeData"] = {
        ...node_data
      };
      let id = node_data.id;
      console.log(`node color ${node_data.title}: ${node_data.hex_color}`);
      node_repsentation.title = (<div className="container-fluid prefernces-item">
        <NodeTollip title={node_data.description} TransitionComponent={Zoom} enterDelay={1000} arrow>
        {/*<div>
                <i class={node_data.icon}></i>
              </div>*/
        }
        <div className="row">
          <div className="col-md-3 col-sm-12 px-0 node-title justify-content-center" style={{
              overflow: "hidden"
            }}>
              <PrefernceLink  prefData={node_data}>
                <span className="title"  >
                  {node_data.title}
                </span>
              </PrefernceLink>
          </div>
          <div className="col-md-9 col-sm-12 " style={{
              display: 'inline-block'
            }}>
            <span className="slider-icon none-sm" >
              <i class={node_data.icon}></i>
            </span>
            <MyRangeInput label={""} value={nodeContext.wight} color={node_data.hex_color} onChange={async (v) => {
                await props.setNodeWight(id, v);
              }} loading={props.loadingTreeContextState == RUNNING}/>
          </div>
        </div>
        </NodeTollip>
      </div>)
      node_repsentation.id = id
      if (node_repsentation.children) {
        node_repsentation.children = node_data.children.filter(_shouldShowNode).map((node) => {
          return _getNodeRepsentation(node)
        })
      } else {
        node_repsentation.children = []
      }
      node_repsentation.named = node_data.title
      return node_repsentation
    }
    return <div></div>;
  }
  const _getTreeRepsentation = (tree_data_build) => {
    console.log("loading data into tree");
    console.log(tree_data_build);
    if (tree_data_build) {
      let tree_repesntation = []
      let mainBranches = tree_data_build
        ? tree_data_build[0].children
        : [];
      if (mainBranches) {
        tree_repesntation = mainBranches.filter(_shouldShowNode).map((node) => {
          return _getNodeRepsentation(node)
        })
      }
      return tree_repesntation;
    }
    return [
      {
        title: "there was an error with loading the tree"
      }
    ]
  }

  const _refreshTreeRepesntation = () => {
    if (treeRepesntation && treeRepesntation.length > 0) {
      console.log("refreshing tree repsintation");
      console.log(treeRepesntation);
      const newRepsentation = treeRepesntation.filter(_shouldShowNode).map((node) => {
        return _refreshNoodRepesntation(node)
      })
      console.log(newRepsentation);
      setTreeRepesntation(newRepsentation)
    }
  }


  const _refreshNoodRepesntation = (nodeRepsentation) => {
    if (nodeRepsentation) {
      let newNodeRepsentation = nodeRepsentation;
      let id = nodeRepsentation.id;
      let nodeContext = props.nodesData[id]
        ? props.nodesData[id]
        : {};
      let named = nodeRepsentation.named
      console.log(`node color ${nodeRepsentation.title}: ${nodeRepsentation.hex_color}`);
      newNodeRepsentation.title = (<div className="container-fluid prefernces-item prefernceNode">
        <NodeTollip title={nodeRepsentation.description} TransitionComponent={Zoom} enterDelay={1000}  arrow>
        {/*<span className={"tollip"}>
          {nodeRepsentation.description}
        </span>*/}
        <div className="row">
          <div className="col-md-3 col-sm-12 px-0   node-title justify-content-center" align="center" style={{
              overflow: "hidden"
            }}>
              <PrefernceLink prefData={nodeRepsentation.nodeData}>
                <span  className="title">
                  {named}
                </span>
              </PrefernceLink>
          </div>
          <div className="col-md-9 col-sm-12 " style={{
              display: 'inline-block'
            }}>
            <span className="slider-icon none-sm" >
              <i class={nodeRepsentation.icon}></i>
            </span>
            <MyRangeInput
              loading={props.loadingTreeContextState == RUNNING} label={""} value={nodeContext.wight} color={nodeRepsentation.hex_color} onChange={async (v) => {
                await props.setNodeWight(id, v)
              }}/>
          </div>
        </div>
      </NodeTollip>
      </div>)
      newNodeRepsentation.id = id
      if (newNodeRepsentation.children) {
        newNodeRepsentation.children = nodeRepsentation.children.filter(_shouldShowNode).map((node) => {
          return _refreshNoodRepesntation(node)
        })
      } else {
        newNodeRepsentation.children = []
      }
      return newNodeRepsentation
    }
    return <div></div>;
  }
  const windowWidth = window.innerWidth;
  let ROW_HEIGHT = 40;
  if(windowWidth < 500){
    console.log("On Mobile");
    ROW_HEIGHT = 75;
  }
  else{
    console.log("On Big Screen");
  }
  const PADDING = 6;
  const rowsAmount = treeRepesntation
    ? treeRepesntation.length
    : 1;
  const height = ROW_HEIGHT * rowsAmount + 2 * PADDING
  console.log("tree:");
  console.log(treeRepesntation);
  return (
    <div style={{height:"800px"}}>
      <SortableTree canDrag={false} scaffoldBlockPxWidth={20} rowHeight={ROW_HEIGHT} theme={FileExplorerTheme} onChange={(newTreeRepesntation) => {
          setTreeRepesntation(newTreeRepesntation)
        }} treeData={treeRepesntation} generateNodeProps={({node, path}) => ({
          style: {
            fontSize: 12,
            textAlign: 'center'
          }
        })}/>
    </div>

  );
}

const mapStateToProps = (state) => ({
  /*treeBuildData: state.treeData.treeBuildData,
  nodesData: state.treeData.nodesData,*/
  preferenceTree: state.preferenceTree,
  nodesData: state.nodesData,
  queryParams: state.optionQueryParams,
  loadingTreeContextState: state.processManager.processes[DOWNLOAD_CONTEXT_PROCESS],

})

const actionsCreators = {
  setNodeWight: setNodeWight,
  setNodeDefWight: setNodeDefWight,
  setPickedNodeId: setPickedNodeId,
  setTreeBuildData: setTreeBuildData,
  setNodesData: setNodesData,
  setTreeData: setTreeData,
  calculteScores: calculteScores,
  setPickedTreeId: setPickedTreeId,
  getTreeData: getTreeData,
  setTreeData: setTreeData,
  loadOptions: throttledLoadOptions,
  addOptionQueryParam: addOptionQueryParam,
  setPrefernceItem: setPrefernceItem
}

export default connect(mapStateToProps, actionsCreators)(ShowLogicTree)
